var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content pb-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{class:_vm.col},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }